import { readableColor } from 'polished';

const FALLBACK_TEXT_COLOR = '#000';

/**
 * Single source of truth for auto-deciding black vs white text against a
 * branded background color. Mirrors Commonplace, which relies on polished's
 * readableColor defaults (luminance threshold 0.179 -> '#000' or '#fff'),
 * so both products make identical contrast decisions.
 *
 * An unparsable background renders as transparent over the white page, so
 * black is the readable choice when parsing fails.
 */
export function readableTextColor(backgroundColor: string): string {
  try {
    return readableColor(backgroundColor);
  } catch {
    return FALLBACK_TEXT_COLOR;
  }
}
